var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 7.8335C3.03486 7.8335 3.33333 8.13197 3.33333 8.50016V13.8335C3.33333 14.0103 3.40357 14.1799 3.5286 14.3049C3.65362 14.4299 3.82319 14.5002 4 14.5002H12C12.1768 14.5002 12.3464 14.4299 12.4714 14.3049C12.5964 14.1799 12.6667 14.0103 12.6667 13.8335V8.50016C12.6667 8.13197 12.9651 7.8335 13.3333 7.8335C13.7015 7.8335 14 8.13197 14 8.50016V13.8335C14 14.3639 13.7893 14.8726 13.4142 15.2477C13.0391 15.6228 12.5304 15.8335 12 15.8335H4C3.46957 15.8335 2.96086 15.6228 2.58579 15.2477C2.21071 14.8726 2 14.3639 2 13.8335V8.50016C2 8.13197 2.29848 7.8335 2.66667 7.8335Z",
    fill: "#73007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4701 10.9712C8.20975 11.2316 7.78764 11.2316 7.52729 10.9712L4.86063 8.30457C4.60028 8.04422 4.60028 7.62211 4.86063 7.36177C5.12098 7.10142 5.54309 7.10142 5.80344 7.36177L7.33203 8.89036L7.33203 1.83317C7.33203 1.46498 7.63051 1.1665 7.9987 1.1665C8.36689 1.1665 8.66537 1.46498 8.66537 1.83317L8.66536 8.89036L10.194 7.36177C10.4543 7.10142 10.8764 7.10142 11.1368 7.36177C11.3971 7.62212 11.3971 8.04423 11.1368 8.30457L8.4701 10.9712Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1a1df6a3daf10f9b1174df09aeda5b4d.svg";
export { ForwardRef as ReactComponent };